import { useState, useEffect, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
    fetchEsnekPosSettings,
    upsertEsnekPosSettings,
    deleteEsnekPosSettings
} from "../../../api/requests/company-requests";

export const useEsnekPosSettings = (companyId) => {
    const [loading, setLoading] = useState(false);
    const [hasSettings, setHasSettings] = useState(false);
    const [settingsId, setSettingsId] = useState(null);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyId: companyId || "",
            merchant: "",
            merchantKey: "",
            merchantPublicToken: "",
            testMode: false
        },
        validationSchema: Yup.object({
            companyId: Yup.string().required("Gerekli"),
            merchant: Yup.string().required("Merchant gerekli"),
            merchantKey: Yup.string().required("Merchant Key gerekli")
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = {
                    companyId: values.companyId,
                    merchant: values.merchant,
                    merchantKey: values.merchantKey,
                    merchantPublicToken: values.merchantPublicToken,
                    testMode: values.testMode
                };

                const res = await upsertEsnekPosSettings(payload);
                if (res?.success || res?.data) {
                    setHasSettings(true);
                    if (res?.data?.id) setSettingsId(res.data.id);
                    toast.success("Hoppa ayarları güncellendi");
                } else {
                    toast.error(res?.message || "Hoppa ayarları kaydedilemedi");
                }
            } catch (error) {
                toast.error("Hoppa ayarları kaydedilirken hata oluştu");
            } finally {
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        if (!companyId) return;

        const loadSettings = async () => {
            try {
                const res = await fetchEsnekPosSettings(companyId);

                if (res?.data) {
                    setHasSettings(true);
                    setSettingsId(res.data.id ?? null);
                    formik.setValues({
                        companyId,
                        merchant: res.data.merchant ?? "",
                        merchantKey: res.data.merchantKey ?? "",
                        merchantPublicToken: res.data.merchantPublicToken ?? "",
                        testMode: res.data.testMode ?? false
                    });
                } else {
                    setHasSettings(false);
                    setSettingsId(null);
                }
            } catch (error) {
                console.error("EsnekPos ayarları yüklenemedi", error);
                setHasSettings(false);
                setSettingsId(null);
            }
        };

        loadSettings();
    }, [companyId]);

    // Bağlantıyı kaldır: backend'deki kaydı siler ama girilen form bilgilerini
    // olduğu gibi bırakır (tekrar bağlanmak isterse yeniden yazmasın diye).
    const disconnect = useCallback(async () => {
        // Henüz kaydedilmemiş (yerel) bağlantı → sadece bağlı durumunu düşür.
        if (!settingsId) {
            setHasSettings(false);
            return true;
        }
        try {
            const res = await deleteEsnekPosSettings(settingsId);
            if (res?.statusCode === 200 || res?.data === true) {
                setHasSettings(false);
                setSettingsId(null);
                return true;
            }
            return false;
        } catch (error) {
            console.error("Hoppa bağlantısı kaldırılamadı", error);
            return false;
        }
    }, [settingsId]);

    return { formik, loading, hasSettings, disconnect };
};
